import { render, staticRenderFns } from "./close-popover.vue?vue&type=template&id=e0540c96&scoped=true"
import script from "./close-popover.vue?vue&type=script&lang=js"
export * from "./close-popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0540c96",
  null
  
)

export default component.exports